import { track } from "@/pwa/analytics";

// Registers the service worker in production only (dev keeps hot-reload intact).
// Surfaces an update-available signal the app can act on.
export function registerSW() {
  if (typeof window === "undefined" || !("serviceWorker" in navigator)) return;
  if (process.env.NODE_ENV !== "production") return;

  window.addEventListener("load", () => {
    navigator.serviceWorker
      .register("/sw.js")
      .then((reg) => {
        reg.addEventListener("updatefound", () => {
          const nw = reg.installing;
          if (!nw) return;
          nw.addEventListener("statechange", () => {
            // A new SW is installed and an old one controls the page → update ready.
            if (nw.state === "installed" && navigator.serviceWorker.controller) {
              (window as unknown as { __pwaWaiting?: ServiceWorker | null }).__pwaWaiting = reg.waiting;
              window.dispatchEvent(new CustomEvent("pwa:update-available"));
              track("pwa_update_available");
            }
          });
        });
      })
      .catch(() => {
        /* registration failure must not break the app */
      });

    let refreshing = false;
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (refreshing) return;
      refreshing = true;
      window.location.reload();
    });
  });
}
